import App from "./App"

const app = new App({
    parent: document.getElementById(
        "ed-app-root"
    )
})

app.render()